export default __webpack_public_path__ + "static/media/handShake.2e5d982e.svg";